import { useMemo } from "react";
import BasicTable from "../../../../utils/BasicTable";

const RetentionTable = ({ data, renewalGoal, onDisplayDetails }) => {
    const columns = useMemo(
        () => [
            {
                Header: "Period",
                accessor: "period",
                Cell: (props) => props.value,
            },
            {
                Header: "Retained",
                accessor: "retained",
                Cell: (props) => {
                    return (
                        <span
                            className="text-teal-500 cursor-pointer"
                            onClick={() =>
                                onDisplayDetails({
                                    quarterName: props.row.original.period
                                        ? props.row.original.period
                                        : null,
                                    metric: "retained",
                                })
                            }
                        >
                            {props.value}
                        </span>
                    );
                },
            },
            {
                Header: "Churned",
                accessor: "churned",
                Cell: (props) => {
                    return (
                        <span
                            className="text-red-500 cursor-pointer"
                            onClick={() =>
                                onDisplayDetails({
                                    quarterName: props.row.original.period
                                        ? props.row.original.period
                                        : null,
                                    metric: "churned",
                                })
                            }
                        >
                            {" "}
                            {props.value}
                        </span>
                    );
                },
            },
            {
                Header: "Total",
                accessor: "total",
                Cell: (props) => {
                    return (
                        <span
                            className="text-black cursor-pointer"
                            onClick={() =>
                                onDisplayDetails({
                                    quarterName: props.row.original.period
                                        ? props.row.original.period
                                        : null,
                                    metric: "total",
                                })
                            }
                        >
                            {" "}
                            {props.value}
                        </span>
                    );
                },
            },
            {
                Header: "% Renewed",
                accessor: "percentRenewed",
                Cell: (props) => {
                    const value = props.value;
                    const color = value < renewalGoal ? "red" : "green";
                    return <span style={{ color }}>{value}%</span>;
                },
            },
        ],
        [renewalGoal, onDisplayDetails]
    );
    return (
        <div>
            <BasicTable columns={columns} data={data} />
        </div>
    );
};

export default RetentionTable;
